export enum EApiLibrary {
  authorize = 'authorize',
  refreshToken = 'refreshToken',
  authenticate = 'authenticate',
  logout = 'logout',
  resetPasswordEmail = 'resetPasswordEmail',
  resetPasswordWithCode = 'resetPasswordWithCode',
}
